import InvoiceData from "./InvoiceData";

export default InvoiceData;
